import { Github, Linkedin, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    {
      name: 'GitHub',
      href: 'https://github.com/famoruwa',
      icon: Github,
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/in/felixamoruwa',
      icon: Linkedin,
    },
    {
      name: 'Twitter',
      href: 'https://twitter.com/Felix_Amoruwa',
      icon: Twitter,
    },
    {
      name: 'Email',
      href: 'mailto:famoruwa@berkeley.edu',
      icon: Mail,
    },
  ];

  return (
    <footer className="border-t bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <div className="flex items-center space-x-2">
            <div className="h-6 w-6 rounded-full bg-primary-600 flex items-center justify-center">
              <span className="text-white font-bold text-xs">FA</span>
            </div>
            <span className="font-semibold">Felix Amoruwa</span>
          </div>

          <div className="flex items-center space-x-6">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
                aria-label={link.name}
              >
                <link.icon size={20} />
              </a>
            ))}
          </div>

          <div className="text-sm text-muted-foreground">
            © {currentYear} Felix Amoruwa. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 